import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../auth/AuthContext";
import { AuthAside, AuthLegal, GoogleIcon } from "../components/AuthAside";
import "./Auth.css";

export default function Register() {
  const { user, register, googleLogin } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const planParam = params.get("plan");
  const dest = planParam ? `/account?plan=${planParam}` : "/welcome";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate(dest, { replace: true }); }, [user, navigate, dest]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    setLoading(true);
    try {
      await register(name, email, password);
      navigate(dest, { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-shell">
      <AuthAside />
      <main className="auth-main">
        <div className="auth-card" data-testid="register-card">
          <h1 className="auth-title">Create account</h1>

          {error && <div className="auth-error" data-testid="register-error">{error}</div>}

          <form onSubmit={submit} className="auth-form">
            <div className="auth-field">
              <label htmlFor="register-name-input">Full name</label>
              <input id="register-name-input" value={name} onChange={(e) => setName(e.target.value)}
                required autoComplete="name" data-testid="register-name" />
            </div>
            <div className="auth-field">
              <label htmlFor="register-email-input">Email</label>
              <input id="register-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                required autoComplete="email" data-testid="register-email" />
            </div>
            <div className="auth-field">
              <label htmlFor="register-pw-input">Password</label>
              <input id="register-pw-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required autoComplete="new-password" placeholder="At least 8 characters" data-testid="register-password" />
            </div>
            <button className="auth-btn" type="submit" disabled={loading} data-testid="register-submit">
              {loading ? "Creating account…" : "Create account"}
            </button>
          </form>

          <div className="auth-divider"><span>or</span></div>

          <button className="auth-google" onClick={googleLogin} data-testid="google-signup-btn">
            <GoogleIcon /> Continue with Google
          </button>

          <p className="auth-foot">
            Already have an account?{" "}
            <Link to="/login" data-testid="goto-login">Sign in</Link>
          </p>
        </div>

        <AuthLegal />
      </main>
    </div>
  );
}
